module.exports = __webpack_public_path__ + "static/media/PR-3.3d877e2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/services/PR-3.jpg
// module id = 101
// module chunks = 0